import { Component, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import {
  HelpTarget,
  NavigationTarget,
  Setting,
  SettingTarget
} from "src/app/interfaces/helpTarget";
import { AbstractSettingsService } from "src/app/settings/abstractSettingsService";

@Component({
    selector: "circ-settings",
    templateUrl: "./settings.component.html",
    styleUrls: ["./settings.component.scss"],
    standalone: false
})
export class SettingsComponent implements OnInit {
  public settings: Setting[] = [];
  public navigation: Setting[] = [];
  constructor(private settingsService: AbstractSettingsService) {}
  public ngOnInit(): void {
    const helpTargets = [
      HelpTarget.Circulation,
      HelpTarget.Steps,
      HelpTarget.Tasks,
      HelpTarget.Metadata
    ];
    const navigationTargets = [NavigationTarget.Ece, NavigationTarget.AboutMe];
    helpTargets.forEach((t) =>
      this.settingsService
        .GetSettingLink(SettingTarget[SettingTarget.HelpTarget], HelpTarget[t])
        .pipe(first())
        .subscribe((v) => {
          this.settings.push({
            key: {
              area: SettingTarget[SettingTarget.HelpTarget],
              key: HelpTarget[t]
            },
            value: v
          });
        })
    );
    navigationTargets.forEach((t) =>
      this.settingsService
        .GetSettingLink(
          SettingTarget[SettingTarget.NavigationTarget],
          NavigationTarget[t]
        )
        .pipe(first())
        .subscribe((v) => {
          this.navigation.push({
            key: {
              area: SettingTarget[SettingTarget.NavigationTarget],
              key: NavigationTarget[t]
            },
            value: v
          });
        })
    );
  }
}
